waterproofs-checkboxes
  .checkboxes(class="{props.type} {props.mobile ? 'sp' : 'pc'}")
    .labels
      template(each="{(waterproofsMaster, index) in state.waterproofsMasters}")
        label
          template(if="{props.type === 'in_modal'}")
            img(src="{checkboxOnIcon}" class="checkbox-icon { state.waterproofses.includes(waterproofsMaster.waterproofs) ? '' : 'hidden' }")
            img(src="{checkboxOffIcon}" class="checkbox-icon { state.waterproofses.includes(waterproofsMaster.waterproofs) ? 'hidden' : '' }")
          input.wp(type="checkbox" onchange="{didChangeWaterproofs}" name="wp[{index + 1}]" value="{waterproofsMaster.waterproofs}"
                checked="{state.existWaterproofs.includes(waterproofsMaster.waterproofs)}")
          | { waterproofsMaster.text }
      label
        template(if="{ props.type === 'in_modal' }")
          img(src="{checkboxOnIcon}" class="checkbox-icon { state.waterproofsRanges.includes('301-9999') ? '' : 'hidden' }")
          img(src="{checkboxOffIcon}" class="checkbox-icon { state.waterproofsRanges.includes('301-9999') ? 'hidden' : '' }")
        input.wpr(type="checkbox" onchange="{didChangeWaterproofsRange}" name="wpr[0]" value="301-9999"
                  checked="{ state.existWaterproofsRanges.includes('301-9999') }")
        | 300m以上
    .selects
      input.wpr(type="hidden" name="wpr[1]" value="{state.selectedWaterproofsRange}")
      .select-wrap
        select(name="waterproofs_bottom" id="waterproofs_bottom" onchange="{didSelectWaterproofsRange}")
          option
          option(value="0" selected="{ '0' === state.initialBottom }") 下限なし
          option(each="{waterproofsMaster in state.waterproofsMasters}" value="{ waterproofsMaster.waterproofs }"
                selected="{ waterproofsMaster.waterproofs === state.initialBottom }") { waterproofsMaster.text }
      | &nbsp;〜&nbsp;
      .select-wrap
        select(name="waterproofs_top" id="waterproofs_top" onchange="{didSelectWaterproofsRange}")
          option
          option(value="9999" selected="{ '9999' === state.initialTop }") 上限なし
          option(each="{waterproofsMaster in state.waterproofsMasters}" value="{ waterproofsMaster.waterproofs }"
                selected="{ waterproofsMaster.waterproofs === state.initialTop }") { waterproofsMaster.text }
  style(type="scss").
    .checkboxes {
      .labels {
        display: flex;
        flex-wrap: wrap;
        label {
          display: flex;
          align-items: center;
          width: calc(100% / 3);
          input {
            margin-right: 4px;
          }
        }
      }
      .selects {
        select {
          color: #015205;
          font-weight: bold;
          border-color: #c8c8c8;
        }
      }
      &.in_sidebar {
        margin-top: 10px;
        border-top: 2px solid #e8e8e8;
        border-bottom: 1px solid #e8e8e8;
        .labels {
          label {
            border-top: 1px solid #e8e8e8;
            border-bottom: 2px solid #e8e8e8;
            border-left: 1px solid #e8e8e8;
            padding: 12px 3px;
            &:nth-child(3n+1) {
              border-left: 0;
            }
          }
        }
        .selects {
          width: 100%;
          border-top: 1px solid #e8e8e8;
          border-bottom: 2px solid #e8e8e8;
          padding: 13px 0;
          text-align: center;
          font-size: 12px;
          select {
            font-size: 12px;
          }
        }
        &.pc {
          .selects {
            display: flex;
            justify-content: center;
            align-items: baseline;
          }
          label {
            a {
              font-size: 12px;
              &:hover {
                text-decoration: underline;
              }
            }
          }
        }
        &.sp {
          margin-top: 16px;
          border-bottom: 0;
          .labels {
            label {
              border-top: 0;
              border-left-width: 2px;
              font-size: 15px;
              padding: 8px 6px;
            }
          }
          .selects {
            border-top: 0;
            font-size: 16px;
            text-align: left;
            padding: 13px;
            select {
              width: 30%;
              height: 20px;
              border: none;
              margin-right: 4px;
            }
          }
        }
      }
      &.in_modal {
        margin-right: -5.625vw;
        width: calc(100% + 5.625vw);
        .labels {
          width: 100%;
          row-gap: 11.25vw;
        }
        label {
          width: calc(100% / 3);
          color: #6c6c6c;
          font-size: 4.6875vw;
          font-weight: 700;
          display: flex;
          align-items: center;
          input {
            display: none;
          }
          .checkbox-icon {
            height: 6.40625vw;
            width: 6.40625vw;
            margin-right: 1.25vw;
            &.hidden {
              display: none;
            }
          }
        }
        .selects {
          margin-top: 11.25vw;
          color: #a1a1a1;
          padding: 0;
          display: flex;
          align-items: center;
          font-size: 5vw;
          .select-wrap {
            width: 40.625vw;
            display: flex;
            align-items: center;
            position: relative;
            &::after {
              content: "▼";
              color: #a1a1a1;
              font-size: 5vw;
              line-height: 1;
              position: absolute;
              top: calc(50% - 2.5vw);
              right: 2.1875vw;
            }
          }
          select {
            border: 0.46875vw solid #e8e8e8;
            color: #5b5b5b;
            font-size: 4.6875vw;
            font-weight: 700;
            height: 15.625vw;
            width: 40.625vw;
            appearance: none;
            background: #ffffff;
            margin: 0;
            padding-left: 3.28125vw;
          }
        }
      }
    }
  script.
    import checkboxOnIcon from 'tags/smartsearch/checkbox_t.png'
    import checkboxOffIcon from 'tags/smartsearch/checkbox_f.png'
    import SmartsearchMaster from 'models/smartsearch-master.js'

    const getExistQuery = (key) => {
      const result = (new RegExp('[?&]'+encodeURIComponent(key)+'=([^&]*)')).exec(location.search)
      if(result) return result[1]
    }

    export default {
      checkboxOnIcon,
      checkboxOffIcon,
      onBeforeMount(props, state) {
        const masterData = new SmartsearchMaster()
        state.waterproofsMasters = masterData.waterproofsMasters
        state.waterproofsValues = state.waterproofsMasters.map(current => current.waterproofs)
        state.initialBottom = '0'
        state.initialTop = '9999'

        state.existWaterproofs = []
        state.existWaterproofsRanges = []
        state.waterproofses = []
        state.waterproofsRanges = []
      },
      didSelectWaterproofsRange() {
        const bottom = this.root.querySelector('#waterproofs_bottom').value
        const top = this.root.querySelector('#waterproofs_top').value
        if (!bottom && !top || Number(top) < Number(bottom)) {
          this.update({
            selectedWaterproofsRange: undefined
          })
          this.didChangeWaterproofsRange()
          return
        }
        if (!bottom || !top) return

        this.update({
          selectedWaterproofsRange: bottom + '-' + top
        })
        this.didChangeWaterproofsRange()
      },
      didChangeWaterproofsRange() {
        const waterproofsRangeElements = this.root.querySelectorAll('.checkboxes input.wpr')
        const waterproofsRanges = Array.prototype.map.call(waterproofsRangeElements, (c) => {
          return c.checked || c.type == 'hidden' ? c.value : ''
        }).filter(range => range.length > 0)

        const waterproofsRangeQuery = waterproofsRanges.join(',')
        this.update({
          waterproofsRangeQuery,
          waterproofsRanges
        })
        this.props.onUpdate(this.state.waterproofsQuery, waterproofsRangeQuery)
      },
      didChangeWaterproofs() {
        const waterproofsElements = this.root.querySelectorAll('.checkboxes input.wp')
        const waterproofses = Array.prototype.map.call(waterproofsElements, (c) => {
          return c.checked || c.type == 'hidden' ? c.value : ''
        }).filter(range => range.length > 0)
        const waterproofsQuery = waterproofses.join(',')
        this.update({
          waterproofsQuery,
          waterproofses
        })
        this.props.onUpdate(waterproofsQuery, this.state.waterproofsRangeQuery)
      },
      initializeByExistQuery() {
        const existWaterproofs = getExistQuery('wp')
        if(existWaterproofs) {
          this.state.existWaterproofs = decodeURIComponent(existWaterproofs).split(',')
          this.state.waterproofses = this.state.existWaterproofs
        }
        const existWaterproofsRange = getExistQuery('wpr')
        if(existWaterproofsRange) {
          this.state.existWaterproofsRanges = decodeURIComponent(existWaterproofsRange).split(',')
          this.state.waterproofsRanges = this.state.existWaterproofsRanges
          const selectedWaterproofsRange = this.state.existWaterproofsRanges.filter( (range) => {
            return range != '301-9999'
          })
          if(selectedWaterproofsRange.length < 1) {
            this.update()
            return
          }

          this.state.selectedWaterproofsRange = selectedWaterproofsRange[0]
          const selectedWaterproofs = this.state.selectedWaterproofsRange.split('-')
          if(selectedWaterproofs.length < 2) return

          this.state.initialBottom = selectedWaterproofs[0]
          this.state.initialTop = selectedWaterproofs[1]
        }
        this.update()
      },
      urlFromValueWithFormData(value) {
        const queryKey = 'wp'
        if (!this.props.formdata) return

        const formDataObj = Object.fromEntries(Array.from(this.props.formdata.entries()))

        const currentValues = (this.state.waterproofsQuery || '').split(',')
        if (!currentValues.includes(value)) {
          const values = Array.from(this.state.waterproofsValues).filter( v => (currentValues.includes(v) || value == v) )
          formDataObj[queryKey] = values.join(',')
        }
        const formDataArray = Array.from(Object.entries(formDataObj)).sort( (kv1, kv2) => {
          if (kv1 < kv2) { return -1 }
          else if (kv1 > kv2) { return 1 }
          else return 0
        })
        const url = '/watches/?' + formDataArray.filter( kv => !!kv[1] ).map( kv => kv[0] + '=' + kv[1] ).join('&')
        return url
      },
      urlFromValueWithFormDataForRange(value) {
        const queryKey = 'wpr'
        if (!this.props.formdata) return

        const formDataObj = Object.fromEntries(Array.from(this.props.formdata.entries()))

        const currentValues = (this.state.waterproofsRangeQuery || '').split(',')
        if (!currentValues.includes(value)) {
          const values = Array.from(currentValues)
          values.unshift('301-9999')
          formDataObj[queryKey] = values.join(',')
        }
        const formDataArray = Array.from(Object.entries(formDataObj)).sort( (kv1, kv2) => {
          if (kv1 < kv2) { return -1 }
          else if (kv1 > kv2) { return 1 }
          else return 0
        })
        const url = '/watches/?' + formDataArray.filter( kv => !!kv[1] ).map( kv => kv[0] + '=' + kv[1] ).join('&')
        return url
      },
      onMounted(props, state) {
        this.initializeByExistQuery()
        this.update()
      },
    }
